import SuperFetch from '../helpers/superFetch';
import UrlBuilder from '../helpers/urlBuilder';

const { build } = UrlBuilder;

type GetFormTemplate = (wersjaSzablonuKarty: string) => Promise<Response>;
type GetFormData = (wersjaSzablonuKarty: string, przedmiotId: string) => Promise<Response>;
type SaveFormData = (wersjaSzablonuKarty: string, przedmiotId: string, daneKarty: Form.ValueElements[]) => Promise<Response>;
type SaveInSID = (params: SaveInSIDParams) => Promise<Response>;
type GetCardFromSid = (wersjaSzablonuKarty: string, przedmiotId: string) => Promise<Response>;

export type CopyFormPayload = {
  przedmiotIdSrc: number;
  przedmiotIdDsc: number;
};
interface SaveInSIDParams {
  filter: { name: string; values: any[] }[];
}
type CopyForm = (data: CopyFormPayload) => Promise<Response>;
/**
 * Klasa zawiera metody służące wysyłaniu zapytań do API dotyczących formularzy
 *
 */
class Forms {
  /** pobieranie szablonu do formularza karty przedmiotu */
  getFormTemplate: GetFormTemplate = wersjaSzablonuKarty => {
    const url = build(`kp/temp-table-template`, { filter: { wersjaSzablonuKarty } });
    return SuperFetch.get(url);
  };
  /** pobieranie danych do formularza karty przedmiotu */
  getFormData: GetFormData = (wersjaSzablonuKarty, przedmiotId) => {
    const typDokumentu = 'karta_przedmiotu';
    const url = build(`kp/temp-table-data`, { filter: { wersjaSzablonuKarty, przedmiotId, typDokumentu } });
    return SuperFetch.get(url);
  };
  /** zapis karty przedmiotów / efektów kierunkowych w tabeli tymczasowej */
  saveFormData: SaveFormData = (wersjaSzablonuKarty, przedmiotId, daneKarty) => {
    const typDokumentu = 'karta_przedmiotu';
    return SuperFetch.post(`kp/temp-table-data`, { wersjaSzablonuKarty, przedmiotId, daneKarty, typDokumentu });
  };
  /** kopiowanie karty przedmiotu */
  copyForm: CopyForm = data => {
    return SuperFetch.post(`kp/ztn-karta-przedmiotu-kopiuj`, { ...data });
  };
  /** publikacja karty przedmiotu / efektów kierunkowych */
  saveInSID: SaveInSID = params => {
    const address: string = build(`kp/publikuj`, params);
    return SuperFetch.get(address);
  };
  getCardFromSid: GetCardFromSid = (wersjaSzablonuKarty, przedmiotId) => {
    const typDokumentu = 'karta_przedmiotu';
    const daneKarty = [];
    return SuperFetch.post(`kp/ztn-karta-przedmiotu-clear`, { wersjaSzablonuKarty, przedmiotId, daneKarty, typDokumentu });
  };
}
export default new Forms();
